import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const getConsolidationCartonReturnsCenters = {
  name: "getConsolidationCartonReturnsCenters" as const,
  input: consolidationCartonLabelInputSchema,
  output: z.object({
    returnsCenters: z.array(
      z.object({
        address: FulfillmentOrderAddressSchema.nullable(),
        id: returnsCenterIdFormat.schema,
        name: z.string(),
        unavailableReason: z.string().nullable(),
      }),
    ),
  }),
};
